import React from 'react'
import { Spinner, Box, Text } from '@shopify/polaris'

const BonusProgramSection = ({ bonusProgram, fetchingBonus, t }) => {
	return (
		<div className={'block-white'} style={{ marginTop: 20 }}>
			{fetchingBonus ? (
				<div>
					<Spinner />
				</div>
			) : (
				<div>
					<Box padding="4" maxWidth="500px" marginTop='10'>
						<Text>
					{t("home.partnerLevel")}{" "}
					<span style={{ fontWeight: "bold" }}>
						{bonusProgram.level}
					</span>
				</Text>
				<Text>
					{t("home.giveYou")}{" "}
					<span style={{ fontWeight: "bold" }}>
						{bonusProgram.discount}% discount
					</span>{" "}
					{t("home.toAllServices")}
				</Text>
				<p>
					{t("home.youNeed")}{" "}
					<span style={{ fontWeight: "bold" }}>
						{bonusProgram.need_client}
					</span>{" "}
					{t("home.clientsOrReferrals")}
				</p>
					</Box>
				</div>
			)}
		</div>
	)
}

export default BonusProgramSection

